/* tslint:disable */
/* eslint-disable */
/**
 * My REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: jason.tai@octopus-tech.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Category,
    CategoryFromJSON,
    CategoryFromJSONTyped,
    CategoryToJSON,
} from './Category';
import {
    Product,
    ProductFromJSON,
    ProductFromJSONTyped,
    ProductToJSON,
} from './Product';

/**
 * 
 * @export
 * @interface ProductCategory
 */
export interface ProductCategory {
    /**
     * 
     * @type {Category}
     * @memberof ProductCategory
     */
    categoryByCategoryId?: Category;
    /**
     * 
     * @type {number}
     * @memberof ProductCategory
     */
    categoryId?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductCategory
     */
    order?: number;
    /**
     * 
     * @type {Product}
     * @memberof ProductCategory
     */
    productByProductId?: Product;
    /**
     * 
     * @type {number}
     * @memberof ProductCategory
     */
    productId?: number;
}

export function ProductCategoryFromJSON(json: any): ProductCategory {
    return ProductCategoryFromJSONTyped(json, false);
}

export function ProductCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'categoryByCategoryId': !exists(json, 'categoryByCategoryId') ? undefined : CategoryFromJSON(json['categoryByCategoryId']),
        'categoryId': !exists(json, 'categoryId') ? undefined : json['categoryId'],
        'order': !exists(json, 'order') ? undefined : json['order'],
        'productByProductId': !exists(json, 'productByProductId') ? undefined : ProductFromJSON(json['productByProductId']),
        'productId': !exists(json, 'productId') ? undefined : json['productId'],
    };
}

export function ProductCategoryToJSON(value?: ProductCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'categoryByCategoryId': CategoryToJSON(value.categoryByCategoryId),
        'categoryId': value.categoryId,
        'order': value.order,
        'productByProductId': ProductToJSON(value.productByProductId),
        'productId': value.productId,
    };
}

